var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-unknown-page",attrs:{"data-block-type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }